<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="content">
  <mat-progress-spinner *ngIf="loading" color="primary" mode="indeterminate" diameter="50"></mat-progress-spinner>

  <div *ngIf="!emptyDataMsg">
    <div class="heading">{{ data[0][0].version?.split(',')[0] }}</div>
    <div class="tableHeader">
      <div></div>
      <h4>Request Date</h4>
      <h4>Version</h4>
      <h4>Status</h4>
    </div>
    <div class="tableBody">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node class="d-block" *matTreeNodeDef="let node; when: hasChild">
          <div>
            <div class="tableRow">
              <div>
                <button
                  [style.display]="
                    node.length > 0 && node[0].status === 'COMPLETED' && node[0].expirationStatus !== 'EXPIRED'
                      ? 'block'
                      : 'none'
                  "
                  mat-icon-button
                  matTreeNodeToggle
                >
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                  </mat-icon>
                </button>
              </div>
              <div>
                {{ node[0].requestDate | date : 'medium' }}
              </div>
              <div>
                {{ node[0].version ? node[0].version.substring(node[0].version.indexOf(',') + 1) : '' }}
              </div>
              <div>
                {{ node[0].expirationStatus === 'EXPIRED' ? 'EXPIRED' : node[0].status }}
              </div>
            </div>
            <div
              *ngFor="let n of node; let i = index"
              [style.display]="
                node.length > 0 && node[0].expirationStatus === 'AVAILABLE' && treeControl.isExpanded(node)
                  ? 'block'
                  : 'none'
              "
            >
              <div class="download-tableRow">
                <div></div>
                <div>Part {{ i + 1 }}</div>
                <div></div>
                <a mat-raised-button class="installer-button" [href]="downloadUrl(n.downloadUrl)" [attr.download]="''"
                  >Download</a
                >
              </div>
            </div>
          </div>
        </mat-tree-node>
      </mat-tree>
    </div>
    <mat-paginator
      *ngIf="requestLogs.length > pageSize"
      [pageSize]="pageSize"
      [length]="requestLogs.length"
      (page)="handlePageEvent($event)"
    >
    </mat-paginator>
  </div>

  <span class="h4" *ngIf="!loading && emptyDataMsg">There is no download history to show</span>

  <div class="footer">
    <div class="contact">
      Requests are for the past 30 days.<br />
      File download links expire 7 days after submission.<br />
      Contact your Wind River Account Manager with any order questions.
    </div>
    <button mat-raised-button (click)="close()">close</button>
  </div>
</div>
